/**
 * 予約の表示系ヘルパー（ステータス・時刻・指名）。
 * 画面をまたいで使うためコンポーネントから切り出し
 */

export const RESERVATION_STATUS_LABEL = {
  confirmed: '確定',
  checked_in: '来店中',
  completed: '完了',
  canceled: 'キャンセル',
}

export const RESERVATION_STATUS_COLOR = {
  confirmed: 'primary',
  checked_in: 'success',
  completed: 'grey lighten-1',
  canceled: 'error',
}

export const reservationStatusLabel = status => RESERVATION_STATUS_LABEL[status] || status || ''

export const reservationStatusColor = status => RESERVATION_STATUS_COLOR[status] || 'grey'

/**
 * time型カラムはISO文字列（ダミー日付付き）で返るためHH:mmを抽出する。
 *
 * @param {string|null} timeStr
 * @returns {string|null}
 */
export const reservationTime = timeStr => {
  if (!timeStr) return null
  const match = String(timeStr).match(/(\d{2}):(\d{2})/)

  return match ? `${match[1]}:${match[2]}` : null
}

/**
 * 指名の表示文字列（新形式の複数指名を優先、旧nominatedUserはフォールバック）。
 *
 * @param {object} attrs 予約のattributes相当（nominations / nominatedUser を持つ）
 * @param {string} fallback 指名なしのときに返す文字列
 * @returns {string|null}
 */
/**
 * 来店処理（卓作成）の前に入力が必要な項目のラベルを返す。
 * 卓作成にはコースが無条件で必須（セットの販売履歴＝終了予定・お時間通知の元になるため。
 * 通常の卓作成ウィザード・BE側の検証と同じ規約）
 *
 * @param {object} attrs 予約のattributes相当（course を持つ）
 * @returns {string[]} 不足項目のラベル（不足なしは空配列）
 */
export const checkInMissingItems = attrs => {
  const missing = []
  if (!attrs || !attrs.course) missing.push('コース')

  return missing
}

/**
 * 日別予約ボードの時間帯サマリー（「18時台 1組2名」）を組み立てる。
 * キャンセル・開始時間未定は集計から除外し、深夜（〜5時台）は翌側として最後に並べる
 *
 * @param {object[]} attrsList 予約のattributes相当の配列（status / startTime / customerCount を持つ）
 * @returns {{hour: number, label: string, groups: number, guests: number}[]}
 */
export const buildTimeSlotSummary = attrsList => {
  const slots = new Map();

  (attrsList || []).forEach(attrs => {
    if (!attrs || attrs.status === 'canceled') return
    const time = reservationTime(attrs.startTime)
    if (!time) return

    const hour = Number(time.slice(0, 2))
    const sortKey = hour < 6 ? hour + 24 : hour
    const slot = slots.get(sortKey) || {
      hour, label: `${hour}時台`, groups: 0, guests: 0,
    }
    slot.groups += 1
    slot.guests += Number(attrs.customerCount) || 0
    slots.set(sortKey, slot)
  })

  return [...slots.entries()].sort((a, b) => a[0] - b[0]).map(([, slot]) => slot)
}

export const nominationSummary = (attrs, fallback = '-') => {
  const nominations = attrs.nominations || []
  if (nominations.length > 0) {
    return nominations.map(n => `${n.userName}(${n.nominationName})`).join('・')
  }

  return attrs.nominatedUser?.name || fallback
}
